require('./bootstrap');

require('./components/imageComponent');
require('./components/menuComponent');
require('./components/repeaterComponent');
require('./components/switchComponent');
require('./components/tagifyComponent');

// import Paginator from './components/Paginator';
// window.Paginator = Paginator;
